export default __webpack_public_path__ + "b957a868069ecaace887d7ac800ce944.png";